export const LocationType = {
  COUNTRY: "country",
  CITY: "city"
};
